import { acceptInvoiceRevision, withdrawInvoiceRevision } from '../models/paymentsV2Model';
import { usePaymentCommand } from './usePaymentCommand';
export function useInvoiceRevision(projection, revision, reload) {
  const accept = usePaymentCommand(`revision-accept-${revision.id}`, () => reload({ silent: true }));
  const withdraw = usePaymentCommand(`revision-withdraw-${revision.id}`, () => reload({ silent: true }));
  return { accept, withdraw,
    acceptRevision: values => accept.submit(payload => acceptInvoiceRevision(projection.invoice.id, revision.id, payload), { expected_invoice_version: projection.invoice.version_number, adjust_remainder: values.adjust_remainder || 'none', note: values.note || null }),
    withdrawRevision: values => withdraw.submit(payload => withdrawInvoiceRevision(projection.invoice.id, revision.id, payload), { reason_code: values.reason_code, note: values.note || null }),
  };
}
